import { RetailersBlock } from '@design-system/retailers-block';
import { WhereToBuy } from '@design-system/where-to-buy';

import { NONE, RETAILERS, THIRD_PARTY } from '../../constants';

export const BuyNowButton = ({ buyNowButton, retailers, whereToBuyData }) => {
  switch (buyNowButton.type) {
    case RETAILERS:
      return (
        retailers && (
          <RetailersBlock
            {...retailers}
            isDropdown
            buttonLabel={buyNowButton.label}
          />
        )
      );

    case THIRD_PARTY:
      return whereToBuyData && <WhereToBuy {...whereToBuyData} />;
    case NONE:
    default:
      return null;
  }
};
